// Users.js
import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import Userstable from '../UserTable';
import RoleRequestTable from '../RoleRequest';
import { useNavigate } from 'react-router-dom';

function Users() {
  const [searchTerm, setSearchTerm] = useState('');
  const [showRoleRequests, setShowRoleRequests] = useState(false);
  const navigate = useNavigate();

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleRoleRequestClick = () => {
    setShowRoleRequests(true);
  };

  const handleUserManagementClick = () => {
    setShowRoleRequests(false);
  };

  return (
    <div className="bg-white px-4 py-4">
      <h1 className="text-xl text-black font-bold mt-5 ">User Management</h1>
      <p className="text-gray-600 text-sm flex items-center mb-4">
        Manage system users, roles, permissions, and role requests in one place
      </p>
      <div className="flex flex-col md:flex-row items-center mb-4 space-y-2 md:space-y-0 md:space-x-2">
        <div className="relative w-full md:w-auto flex-1">
          <input
            type="text"
            placeholder="Search with user name"
            value={searchTerm}
            onChange={handleSearchChange}
            className="border rounded-lg py-2 pl-10 pr-4 w-full placeholder:text-sm"
          />
          <span className="absolute left-3 top-3.5 text-gray-500">
            <FaSearch size={16} />
          </span>
        </div>
        <button
          onClick={() => navigate('/dashboard/mdm/users/add')}
          className="bg-black hover:text-white text-white rounded-lg px-6 py-2 text-sm font-semibold"
        >
          Add User
        </button>
        <button
          onClick={showRoleRequests ? handleUserManagementClick : handleRoleRequestClick}
          className="bg-black hover:text-white text-white rounded-lg px-6 py-2 text-sm font-semibold"
        >
          {showRoleRequests ? 'User Management' : 'Role Requests'}
        </button>
        <button
          onClick={() => navigate('/dashboard/mdm/users/manage-roles')}
          className="bg-black hover:text-white text-white rounded-lg px-6 py-2 text-sm font-semibold"
        >
          Manage Roles & Permissions
        </button>
      </div>

      {/* Render the correct table based on the state */}
      {showRoleRequests ? <RoleRequestTable /> : <Userstable searchTerm={searchTerm} />}
    </div>
  );
}

export default Users;

// import React, { useState } from "react";
// import { FaSearch } from "react-icons/fa";
// import Userstable from "../UserTable";
// import AddUserModal from "../AddUser";
// import RoleRequestTable from "../RoleRequest";
// import { useNavigate } from "react-router-dom";

// function Users() {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showAddUserModal, setShowAddUserModal] = useState(false);
//   const [showRoleRequests, setShowRoleRequests] = useState(false); // State to toggle between Userstable and RoleRequestTable
//   const navigate = useNavigate();
//   const handleSearchChange = (event) => {
//     setSearchTerm(event.target.value);
//   };

//   const closeModal = () => {
//     setShowAddUserModal(false);
//   };

//   const handleRoleRequestClick = () => {
//     setShowRoleRequests(true); // Set state to show RoleRequestTable
//   };

//   const handleUserManagementClick = () => {
//     setShowRoleRequests(false); // Set state to show Userstable
//   };

//   return (
//     <div>
//       <h1 className="text-xl text-black font-bold mt-5 mb-2">User Management</h1>
//       <div className="flex flex-col md:flex-row items-center mb-4 space-y-2 md:space-y-0 md:space-x-2">
//         <div className="relative w-full md:w-auto flex-1">
//           <input
//             type="text"
//             placeholder="Search"
//             value={searchTerm}
//             onChange={handleSearchChange}
//             className="border rounded-lg py-2 pl-10 pr-4 w-full focus:outline-none focus:ring-2 focus:ring-gray-400 placeholder:text-sm"
//           />
//           <span className="absolute left-3 top-3.5 text-gray-500">
//             <FaSearch size={16} />
//           </span>
//         </div>
//         <button
//           onClick={() => setShowAddUserModal(true)}
//           className="bg-cyan-500 hover:text-black text-white rounded-lg px-6 py-2 text-sm font-semibold"
//         >
//           Add User
//         </button>
//         <button
//         onClick={() => navigate("/dashboard/mdm/users/manage-roles")}
//         className="bg-cyan-500 hover:text-black text-white rounded-lg px-6 py-2 text-sm font-semibold"
//       >
//         Manage Permissions
//       </button>

//         <button
//           onClick={
//             showRoleRequests
//               ? handleUserManagementClick
//               : handleRoleRequestClick
//           } // Toggle function
//           className="bg-cyan-500 hover:text-black text-white rounded-lg px-6 py-2 text-sm font-semibold"
//         >
//           {showRoleRequests ? "User Management" : "Role Requests"}
//         </button>
//       </div>

//       {/* Render the correct table based on the state */}
//       {showRoleRequests ? (
//         <RoleRequestTable />
//       ) : (
//         <Userstable searchTerm={searchTerm} />
//       )}

//       {/* Render the AddUserModal component conditionally */}
//       {showAddUserModal && <AddUserModal closeModal={closeModal} />}
//     </div>
//   );
// }

// export default Users;
